import PropTypes from 'prop-types';
import React from 'react';

import { StyledLabel, StyledRequiredAsterix } from './styles';

export const Label = ({ required, error, className, htmlFor, children }) => (
  <StyledLabel className={className} error={error} htmlFor={htmlFor}>
    {children}
    {required ? <StyledRequiredAsterix>*</StyledRequiredAsterix> : null}
  </StyledLabel>
);

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  error: PropTypes.bool,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
};

Label.defaultProps = {
  children: undefined,
  className: '',
  error: false,
  htmlFor: '',
  required: false,
};
